// extracted by mini-css-extract-plugin
export default {"root":"x5KpHOgmObsTo9inM3YU"};